import { Model, modelRegistry } from './Model';
import { CashRegister } from '.';
export class Warehouse extends Model {
    static entity = 'warehouses';
    id = null;
    name = '';
    code = null;
    is_default = false;
    is_active = true;
    stocks_count = 0;
    created_at = null;
    updated_at = null;
    cash_registers = [];
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            code: this.attr(null),
            is_default: this.attr(false, value => !!value),
            is_active: this.attr(true, value => !!value),
            stocks_count: this.attr(0, value => Number(value || 0)),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            cash_registers: this.attr([], (value) => (value || []).map(item => new CashRegister(item))),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getDisplayName() {
        return this.code ? `${this.name} (${this.code})` : this.name;
    }
}
export default Warehouse;
modelRegistry.register('Warehouse', Warehouse);
//# sourceMappingURL=Warehouse.js.map